import { FC } from 'react'
import { PlayCircleIcon } from '@/atoms/Icons/PlayCircleIcon'
import { Frame } from '@/types/codegen-federation'

interface Props {
  handleClick: () => void
  hasSignedFrame: boolean
  frame: Frame
}

export const SignedFrameOverlay: FC<Props> = ({ frame, handleClick, hasSignedFrame }) => {
  const aspect = frame?.episode?.canonId === 'his-only-son' ? 'aspect-h-429 aspect-w-1024' : 'aspect-h-9 aspect-w-16'
  const containerStyle = 'absolute bottom-0 w-full'
  return (
    <div className={containerStyle} onClick={() => handleClick()}>
      <div className={aspect}>
        {frame.nifty?.signatures?.[0]?.signatureUrl !== null && (
          <>
            {frame.uri && (
              <div>
                <img src={frame.uri} alt="Personalized signature" className="absolute left-0 top-0 h-full w-full" />
                <PlayCircleIcon
                  size={64}
                  className="absolute left-1/2 top-1/2 z-10 -translate-x-1/2 -translate-y-1/2 transform-gpu cursor-pointer rounded-full bg-black transition-transform duration-300 ease-in-out [backface-visibility:hidden] hover:scale-[1.03]"
                />
              </div>
            )}
            {hasSignedFrame && (
              <img
                src={frame?.nifty?.signatures?.[0]?.signatureUrl ?? ''}
                alt="Personalized signature"
                className="absolute left-0 top-0 h-full w-full"
              />
            )}
          </>
        )}
      </div>
    </div>
  )
}
